/**
 * NotificationIcon.js
 * Written by: Alex Kasemir
 */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Bell from '../../assets/notifications_bell.svg';

import {
  NotificationIconContainer,
  CountBox,
  BellIcon,
} from './NotificationIcon.styles';

export default class NotificationIcon extends Component {
  render() {
    const {
      className,
      onClick,
      loggedIn,
      displayCount,
    } = this.props;

    return (
      <NotificationIconContainer className={className} onClick={onClick}>
        <BellIcon src={Bell} displaycount={displayCount} />
        {displayCount && loggedIn ? (
          <CountBox>
            <div>{displayCount}</div>
          </CountBox>
        ) : null
        }
      </NotificationIconContainer>
    );
  }
}

NotificationIcon.propTypes = {
  className: PropTypes.string,
  onClick: PropTypes.func,
  loggedIn: PropTypes.bool,
  displayCount: PropTypes.number,
};
